import { ROUTES } from '@router'

export function getGoBackTranslationKey({
  route = {},
  translations = {},
} = {}) {
  switch (route.name) {
    case ROUTES.REVIEWS.PAGES.PRODUCT:
      return translations.goBackProduct

    case ROUTES.REVIEWS.PAGES.MERCHANT:
      return translations.goBackSeller

    case ROUTES.REVIEWS.PAGES.LANDING:
      return translations.goBackLanding

    case ROUTES.REVIEWS.PAGES.ALL:
    default:
      return translations.goBackDefault
  }
}
